import {
  SEARCH_PARAM_NAMES,
  EXTERNAL_ORDER_SOURCE_APPS,
  DISPLAY_MODES,
} from 'constants/enums';
import {
  getQueryParam,
  dropSearchParamFromUrl,
} from 'utilities/search_parameters';
import {
  CHECKOUT_LOGIN_REDIRECT_PARAM,
  IDV_QUERY_PARAMS,
} from 'utilities/links';

export const isOrderFromOnboarding = () =>
  getQueryParam(SEARCH_PARAM_NAMES.REFERER)?.toLowerCase() ===
  EXTERNAL_ORDER_SOURCE_APPS.ONBOARDING?.toLowerCase();

export const isDashboardMode = () =>
  getQueryParam(SEARCH_PARAM_NAMES.MODE)?.toLowerCase() ===
  DISPLAY_MODES.DASHBOARD;

export const isSourceQsrHardwareFlow = () =>
  getQueryParam(SEARCH_PARAM_NAMES.SOURCE)?.toLowerCase() ===
  EXTERNAL_ORDER_SOURCE_APPS.QSR_HARDWARE_FLOW;

export const isSourceShopHardwareFlow = () =>
  getQueryParam(SEARCH_PARAM_NAMES.SOURCE)?.toLowerCase() ===
  EXTERNAL_ORDER_SOURCE_APPS.SHOP_HARDWARE_FLOW;

/**
 * Gets the initial progress percentage number from query param.
 * @returns number
 */
export const getInitialProgressPercentageNumber = () =>
  Number(getQueryParam(SEARCH_PARAM_NAMES.INITIAL_PROGRESS));

/**
 * Gets the progress percentage number from query param.
 * @returns number
 */
export const getProgressPercentageNumber = () =>
  Number(getQueryParam(SEARCH_PARAM_NAMES.PROGRESS));

export const getProgressPercentByStep = (
  originalPercent,
  completionRatio = 1,
) => {
  let cleanedOriginalPercent = originalPercent || 0;
  cleanedOriginalPercent = Math.min(cleanedOriginalPercent, 100);
  cleanedOriginalPercent = Math.max(cleanedOriginalPercent, 0);

  const maxShopPercentDifference = 100 - cleanedOriginalPercent;

  const shopPercentageDifference = maxShopPercentDifference * completionRatio;

  return Math.ceil(cleanedOriginalPercent + shopPercentageDifference);
};

export const shouldView3dArModel = () =>
  getQueryParam(SEARCH_PARAM_NAMES.MODEL_VIEW)?.toLowerCase() === 'true';

/**
 * Gets the model number (index) from query param. This is based on the index starting at 1.
 * @returns index
 */
export const get3dArModelNumber = () =>
  Number(getQueryParam(SEARCH_PARAM_NAMES.MODEL_NUMBER));

export const dropViewModelParamFromUrl = () => {
  const url = dropSearchParamFromUrl(undefined, SEARCH_PARAM_NAMES.MODEL_VIEW);
  window.history.replaceState(null, null, url);
};

export const mergeSearchParams = (originalParams, newParams) => {
  const mergedParams = new URLSearchParams(originalParams);

  for (const [key, value] of newParams) {
    mergedParams.set(key, value);
  }

  return mergedParams;
};

/**
 * checks url search params to see if the merchant was redirected from logging in after clicking checkout
 * @returns object - with booleans for each redirect type
 */
export const checkRedirectedFromCheckoutLogin = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const redirectedFromIdv = urlSearchParams.has(IDV_QUERY_PARAMS.REDIRECT);
  const redirectedFromIdvLogin = urlSearchParams.has(IDV_QUERY_PARAMS.LOGIN);
  const redirectedFromCheckoutLogin = urlSearchParams.has(
    CHECKOUT_LOGIN_REDIRECT_PARAM,
  );

  return {
    redirectedFromIdv,
    redirectedFromIdvLogin,
    redirectedFromCheckoutLogin,
  };
};
